import { Commit } from 'vuex';
import { DocumentReglementaireState } from './state';

export enum DocumentReglementaireActions {
    GET_DOCUMENT_REGLEMENTAIRE = 'GET_DOCUMENT_REGLEMENTAIRE',
    GET_DOCUMENT_REGLEMENTAIRE_PDF = 'GET_DOCUMENT_REGLEMENTAIRE_PDF',
    GET_ALL_DOCUMENT_REGLEMENTAIRE_PDF = 'GET_ALL_DOCUMENT_REGLEMENTAIRE_PDF',
    GET_ADR_PDF = 'GET_ADR_PDF',
    GET_ALL_ADR_PDF = 'GET_ALL_ADR_PDF',
    GET_TYPES_DOCUMENTS_REGLEMENTAIRES = 'GET_TYPES_DOCUMENTS_REGLEMENTAIRES',
    GET_PRISE_EN_CHARGE_PDF = 'GET_PRISE_EN_CHARGE_PDF'
}

export interface DocumentReglementaireActionTypes {
    commit: Commit;
    state: DocumentReglementaireState;
    getters: any;
}
